import React from 'react';
import { Router, Route, Redirect, Switch } from 'react-router-dom';
import AuthContainer from './StepOne';
import StepTwoComponent from './StepTwo';
import StepThreeComponent from './StepThree';
import StepFourComponent from './StepFour';
import StepFiveComponent from './StepFive';
import StepSixComponent from './StepSix';
import { checkAuth } from '../../utils/helpers';

const routes = [
  {
    path: '/step/two',
    exact: true,
    component: StepTwoComponent, 
  },
  {
    path: '/step/three',
    exact: true,
    component: StepThreeComponent, 
  },
  {
    path: '/step/four',
    exact: true,
    component: StepFourComponent,
  },
  {
    path: '/step/five',
    exact: true,
    component: StepFiveComponent,
  },
  {
    path: '/step/six',
    exact: true,
    component: StepSixComponent,
  },
];

const AuthenticatedRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      checkAuth() ? (
        <Component {...props} />
      ) : (
        <Redirect to={{ pathname: "/" }} />
      )
    } />
);

export default ({ match, ...props }) => (
  <Switch>
    <Route path={match.url} exact component={AuthContainer} />
    {routes.map((route, i) => (                                
      <AuthenticatedRoute
        key={i}
        exact={route.exact}
        path={`${match.url}${route.path}`}
        component={route.component} />
      ))
    }
  </Switch>
);
